import { createSlice, isAnyOf } from '@reduxjs/toolkit'

import {
  restoreSession,
  authUser,
  signOutUser,
  updatePartnerView,
  fetchSessionUser,
  updateSessionUser,
  updateSessionUserParam,
  updateUserAvatar,
  sandboxSignIn,
} from 'api/sessionUser'

const initialState = {}

const userUpdateMatcher = isAnyOf(
  restoreSession.matchFulfilled,
  authUser.matchFulfilled,
  signOutUser.matchFulfilled,
  updatePartnerView.matchFulfilled,
  fetchSessionUser.matchFulfilled,
  updateSessionUser.matchFulfilled,
  updateSessionUserParam.matchFulfilled,
  updateUserAvatar.matchFulfilled,
  sandboxSignIn.matchFulfilled,
)

export const sessionUserSlice = createSlice({
  name: 'sessionUser',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addMatcher(userUpdateMatcher, (state, { payload }) => {
        // TODO: for debug. Adds new feature locally
        // return {...state, ...payload.user, ...{features: [...(payload?.user?.features || []), 'FEATURE_...']}}
        return { ...state, ...payload.user }
      })

      .addMatcher(signOutUser.matchFulfilled, () => {
        return initialState
      })
  },
})

export default sessionUserSlice.reducer
